import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { API_CONSTANT } from "./api.constant";
import { HttpClientService } from "./http-client.service";

@Injectable()
export class CustomerService {
    constructor(
        private http: HttpClient,
        private httpService: HttpClientService,
    ) {}

    getTaxData(secretCode: string) {
        return this.http.get(`${API_CONSTANT.tax_data}${secretCode}/`)
    }

    approveTaxData(secretCode: string) {
        return this.http.post(`${API_CONSTANT.tax_data}${secretCode}/approve/`, {});
    }

    userApproveTaxData(secretCode: string) {
        return this.httpService.post(`${API_CONSTANT.tax_data}${secretCode}/approve/`, {});
    }

    rejectTaxData(secretCode: string, payload: any) {
        return this.http.post(`${API_CONSTANT.tax_data}${secretCode}/reject/`, payload);
    }
}



// WEBPACK FOOTER //
// /opt/app/src/app/services/customer.service.ts